import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  mapWrapper: {
    height: "85vh",
    width: "100%",
    backgroundColor: "#ffffff",
    overflowY: "auto",
  },
  backdropLoading: { zIndex: 5, color: "#FFFFFF" },
  statusPlanChip: {
    marginLeft: 10,
    backgroundColor: "#F4BF00",
    borderRadius: 5,
  },
  statusPlanActiveChip: {
    marginLeft: 10,
    backgroundColor: "#2196F3",
    borderRadius: 5,
  },
  daysChipFilled: {
    margin: 5,
    backgroundColor: "#667BEA",
    borderRadius: 5,
  },
  daysChip: {
    margin: 5,
    backgroundColor: "#FFFFFF",
    color: "#6B6B6B",
    border: "1px solid #E3E3E3",
    borderRadius: 5,
  },
  panel: {
    backgroundColor: (props: any) =>
      `${props.openRoutePanel ? "#FBFBFB" : "#FFFFFF"}`,
    overflow: "auto",
    maxHeight: "85vh",

    /* width */
    "&::-webkit-scrollbar": {
      width: "3px",
    },

    /* Track */
    "&::-webkit-scrollbar-track": {
      background: "#F8F8F8",
    },

    /* Handle */
    "&::-webkit-scrollbar-thumb": {
      background: "#E1E1E1",
    },

    /* Handle on hover */
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#D8D8D8",
    },
  },
  showPanel: {
    backgroundColor: "#FFFFFF",
    overflow: "auto",
    maxHeight: "85vh",

    /* width */
    "&::-webkit-scrollbar": {
      width: "3px",
    },

    /* Track */
    "&::-webkit-scrollbar-track": {
      background: "#F8F8F8",
    },

    /* Handle */
    "&::-webkit-scrollbar-thumb": {
      background: "#E1E1E1",
    },

    /* Handle on hover */
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#D8D8D8",
    },
  },
  sidePanelBackButton: {
    padding: "10px",
  },
  sidePanelTitle: {
    margin: "4px 0 0 4px",
  },
  sidePanelTabs: {
    borderBottom: "1px solid #C4C4C4",
    "& .MuiTabs-fixed > .MuiTabs-indicator": {
      backgroundColor: "#989898 !important",
      height: "3px !important",
    },
    "& .MuiTabs-fixed > .MuiTabs-flexContainer > .MuiTab-root": {
      minWidth: "100px",
    },
  },
});

export { useStyles };
